/**
 * Chart.js plugin that recolors the first bar (On-Hand) of dataset index 0
 * with a green rounded-top rectangle. Used by Buffer, Logistics, and Coverage
 * management charts.
 */
export const onHandColorPlugin = {
  id: 'onHandColor',
  afterDatasetsDraw(chart: any) {
    const ctx = chart.ctx;
    const meta = chart.getDatasetMeta(0);
    if (meta && meta.data && meta.data.length > 0 && !meta.hidden) {
      const firstBar = meta.data[0];
      if (firstBar && firstBar.y <= firstBar.base) {
        ctx.save();
        ctx.fillStyle = '#10B981';
        const { x, y, base, width } = firstBar;
        const barX = x - width / 2;
        const barY = y;
        const radius = 4;

        // Draw rounded rectangle (rounded top corners only)
        ctx.beginPath();
        ctx.moveTo(barX + radius, barY);
        ctx.lineTo(barX + width - radius, barY);
        ctx.quadraticCurveTo(barX + width, barY, barX + width, barY + radius);
        ctx.lineTo(barX + width, base);
        ctx.lineTo(barX, base);
        ctx.lineTo(barX, barY + radius);
        ctx.quadraticCurveTo(barX, barY, barX + radius, barY);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }
    }
  },
};
